module.exports = __webpack_public_path__ + "img/google.96046446.png";